<template>
  <div class="cube-popup" :style="{'z-index': zIndex}" :class="rootClass" v-show="visible">
    <div class="cube-popup-mask" @touchmove.prevent @click="maskClick">
      <slot name="mask"></slot>
    </div>
    <div class="cube-popup-container" @touchmove.prevent :class="containerClass">
      <div class="cube-popup-content" v-if="$slots.default">
        <slot></slot>
      </div>
      <div class="cube-popup-content" v-else v-html="content">
      </div>
    </div>
  </div>
</template>
<script>
import { computed } from 'vue'
export default {
  name:'cube-popup',
  props: {
    type: {
      type: String,
      default: ''
    },
    mask: {
      type: Boolean,
      default: true
    },
    content: {
      type: String,
      default: ''
    },
    center: {
      type: Boolean,
      default: true
    },
    position: {
      type: String,
      default: ''
    },
    zIndex: {
      type: Number,
      default: 100
    },
    maskClosable: {
      type: Boolean,
      default: false
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  emits:['update:visible','maskClick'],
  setup(props, {emit}){
    const rootClass = computed(()=>{
      const cls = {
        'cube-popup_mask': props.mask
      }
      if (props.type) {
        cls[`cube-${props.type}`] = true
      }
      return cls
    })
    const containerClass = computed(()=>{
      const center = props.center
      const position = props.position
      if (position) {
        return {
          [`cube-popup-${position}`]: true
        }
      }
      if (center) {
        return {
          'cube-popup-center': true
        }
      }
      return {}
    })
    const maskClick = ()=>{
      emit('maskClick')
      if(props.maskClosable){
        emit('update:visible', false)
      }
    }
    return {
      rootClass,
      containerClass,
      maskClick
    }
  }
}
</script>